<template>
  <div class="charge-detail">
    <div class="main-title">
      <p @click="toList">{{ $t('lang.Battery Management') }}</p>
      <p>>{{ $t('lang.Battery Management') }}</p>
    </div>
    <div class="main-body">
      <div class="list">
        <div class="name-label">{{ $t('lang.Device ID') }}：</div>
        <div class="value-label">{{ primaryDeviceNo }}</div>
        <div class="name-label">{{ $t('lang.Communication board number') }}：</div>
        <div class="value-label">{{ communicationBoardNo }}</div>
      </div>
      <div class="list">
        <span>{{ $t('lang.time') }}：</span>
        <el-date-picker v-model="startTime" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.start time')">
        </el-date-picker>
        --
        <el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.end time')">
        </el-date-picker>
        <div class="blue-btn ml10" @click="onQueryBtnClick">{{ $t('lang.Inquire') }}</div>
        <div class="normal-btn ml10" @click="exprotFn">{{ $t('lang.Export') }}</div>
      </div>
      <el-table :data="dataList" style="width: 100%;margin: 20px 0;" class="table-custom">
        <el-table-column prop="snapshot" :label="$t('lang.Equipment snapshot number')" width="250px">
          <template slot-scope="{row}">
            {{ row.number }}
          </template>
        </el-table-column>
        <el-table-column prop="Receiving" :label="$t('lang.Receiving time')" width="150px">
          <template slot-scope="{row}">
            {{ row.createTime }}
          </template>
        </el-table-column>
        <el-table-column prop="Battery" :label="$t('lang.Battery Power')" width="150px">
          <template slot-scope="{row}">
            {{ row.soc }}
          </template>
        </el-table-column>
        <el-table-column prop="Health" :label="$t('lang.Health level')" width="150px">
          <template slot-scope="{row}">
            {{ row.soh }}
          </template>
        </el-table-column>
        <el-table-column prop="current" :label="$t('lang.Battery current')" width="150px">
          <template slot-scope="{row}">
            {{ row.electricCurrent }}
          </template>
        </el-table-column>
        <el-table-column prop="Voltage" :label="$t('lang.Battery Voltage')" width="150px">
          <template slot-scope="{row}">
            {{ row.electricVoltage }}
          </template>
        </el-table-column>
        <el-table-column prop="Differential" :label="$t('lang.Battery Differential')" width="200px">
          <template slot-scope="{row}">
            {{ row.voltageDifference }}
          </template>
        </el-table-column>
        <el-table-column prop="Maximum" :label="$t('lang.Max battery temperature')" width="240px">
          <template slot-scope="{row}">
            {{ row.maxTemperature }}
          </template>
        </el-table-column>
        <el-table-column prop="Minimum" :label="$t('lang.Min battery temperature')" width="240px">
          <template slot-scope="{row}">
            {{ row.minTemperature }}
          </template>
        </el-table-column>
        <el-table-column prop="Discharge" :label="$t('lang.Discharge MOS temperature')" width="240px">
          <template slot-scope="{row}">
            {{ row.dischargeMosTemperature }}
          </template>
        </el-table-column>
        <el-table-column prop="Charge" :label="$t('lang.Charge MOS temperature')" width="220px">
          <template slot-scope="{row}">
            {{ row.chargingMosTemperature }}
          </template>
        </el-table-column>
        <el-table-column prop="Status" :label="$t('lang.Battery Status')" width="150px">
          <template slot-scope="{row}">
            {{ row.userStatus }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="MOS" :label="$t('lang.Battery MOS status')">
          <template slot-scope="{row}">
            {{ row.dischargeMosStatus }}
          </template>
        </el-table-column> -->
        <el-table-column prop="Discharge" :label="$t('lang.Battery') +' ' +$t('lang.Charge MOS state')" width="210px">
          <template slot-scope="{row}">
            {{ row.dischargeMosStatus }}
          </template>
        </el-table-column>
        <el-table-column prop="Charge" :label="$t('lang.Battery')+' '+$t('lang.Discharge MOS state')" width="240px">
          <template slot-scope="{row}">
            {{ row.chargeMosStatus }}
          </template>
        </el-table-column>
        <el-table-column prop="Attribution" :label="$t('lang.Attribution Object')" width="150px">
          <template slot-scope="{row}">
            {{ row.belongTarget }}
          </template>
        </el-table-column>
        <el-table-column prop="Object" :label="$t('lang.Attribution Object Type')" width="200px">
          <template slot-scope="{row}">
             {{ belongTargetTypeMap[row.belongTargetType] }}{{
              row.belongTargetType === '0' ? '，' + row.chargePortSeq +
            '号' : ''
            }} 
          </template>
        </el-table-column>
        <el-table-column prop="Error" :label="$t('lang.Error Code')" width="150px">
          <template slot-scope="{row}">
            {{ row.errorCode }}
          </template>
        </el-table-column>
      </el-table>



      <!-- <div class="page-box">
        <div class="page-count">{{ $t('lang.The') }} {{ pageIndex }} {{ $t('lang.page') }}，{{ $t('lang.The current page') 
        }} {{
  dataList.length }} {{ $t('lang.item') }}，{{ $t('lang.total') }} {{ total }} {{ $t('lang.item') }}</div>
        <div class="page-count">{{ $t('lang.Jump to') }}
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          {{ $t('lang.page') }}
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">{{ $t('lang.Jump to') }}</div>
        <div class="pre-btn" :class="preBtnDisabled ? 'disabled' : ''" @click="onPreBtnClick">{{ $t('lang.Previous page')
        }}
        </div>
        <div class="next-btn" :class="nextBtnDisabled ? 'disabled' : ''" @click="onNextBtnClick">{{ $t('lang.Next page')
        }}
        </div>
      </div> -->
      <div class="dfcc">
        <el-pagination
          :current-page="pageIndex"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10,20, 30, 40,50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('lang.Monomer voltage')" width="30%" :visible.sync="dialogVisible">
      <el-table v-loading="loading" :data="tableData" style="width: 100%" height="250">
        <el-table-column prop="cellSeqNo" :label="$t('lang.Cell voltage number')" width="250">
        </el-table-column>
        <el-table-column prop="electricVoltage" :label="$t('lang.voltage')" width="250">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{ $t('lang.Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'batterySnapShot',
  data() {
    return {
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      total: '',
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dialogVisible: false,
      startTime: '',
      endTime: '',
      communicationBoardNo: '',
      primaryDeviceNo: '',
      statusMap: {
        '-1': '超时',
        '1': '搁置',
        '2': '放电',
        '3': '充电',
      },
      belongTargetTypeMap: {
        '0': '换电柜',
        '1': '用户'
      },
      errorMessageMap: {
        0: '单体电压过高故障',
        1: '单体电压过低故障',
        3: '充电过流故障',
        4: '放电过流故障',
        6: '短路故障',
        8: '电池高温指示',
        9: '电池低温指示',
        13: '采集IC故障',
        14: 'MOS温度过高故障',
        16: '电池总电压过低故障',
        17: '电池总电压过高故障',
        18: '电池压差过大故障',
        20: '采样线故障',
        21: '进水故障'
      },
      errorMessageMapCabine: {
        0: '单体过压保护',
        1: '单体欠压保护',
        2: '整体过压保护',
        3: '整体欠压保护',
        4: '充电过温保护',
        5: '充电低温保护',
        6: '放电过温保护',
        7: '放电低温保护',
        8: '充电过流保护',
        9: '放电过流保护',
        10: '短路保护',
        11: '采样芯片故障'
      },
      dataList: [],
      tableData: [],
      loading: false,
      searchCondition: '',
      belongTarget: '',
      targetNumber: '',
      belongTargetSeq: '',
      version: '',
      status: '',
      manufacturer: '',
      domainType: ''
    }
  },
  mounted() {
    this.startTime = Utils.getCurrentDate() + " 00:00";
    this.endTime = Utils.getCurrentDate() + " 23:59";
    if (this.$route.query.primaryDeviceNo) {
      this.primaryDeviceNo = this.$route.query.primaryDeviceNo;
      this.querySnapshot();
    }
    if (this.$route.query.communicationBoardNo) {
      this.communicationBoardNo = this.$route.query.communicationBoardNo;
    }
    if (this.$route.query.searchCondition) {
      this.searchCondition = this.$route.query.searchCondition;
    }
    if (this.$route.query.belongTarget) {
      this.belongTarget = this.$route.query.belongTarget;
    }
    if (this.$route.query.targetNumber) {
      this.targetNumber = this.$route.query.targetNumber;
    }
    if (this.$route.query.belongTargetSeq) {
      this.belongTargetSeq = this.$route.query.belongTargetSeq;
    }
    if (this.$route.query.version) {
      this.version = this.$route.query.version;
    }
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
    }
    if (this.$route.query.manufacturer) {
      this.manufacturer = this.$route.query.manufacturer;
    }
    if (this.$route.query.beginIndex) {
      this.listBeginIndex = this.$route.query.beginIndex;
    }
    let domain = Utils.getDomain();
    if (domain == 'iot.lititi.com' || domain == 'hailixinnengyuan.com' || domain == 'leasehold-test.lititi.com') {
      this.domainType = '2';
    }
  },
  methods: {
    querySnapshot() {
      let self = this;
      let params = {
        batteryNo: this.primaryDeviceNo,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        beginTime: this.startTime,
        endTime: this.endTime
      };
      this.$http.post('/managementPlatform/electricity/queryBatterySnapshot', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        let list = res.ldata;
        list.forEach(v => {
          if (v.errorCodeInfo && v.errorCodeInfo != "正常") {
            let errorCode = v.errorCode;
            let errorData = [];
            if (v.belongTargetType == 0) {
              for (let i = 0; i < errorCode.length - 1; i++) {
                if (errorCode.charAt(i) == '1') {
                  errorData.push({
                    error: self.errorMessageMapCabine[i]
                  })
                }
              }
            } else {
              for (let i = 0; i < errorCode.length - 1; i++) {
                if (errorCode.charAt(i) == '1') {
                  errorData.push({
                    error: self.errorMessageMap[i]
                  })
                }
              }
            }
            v.errorData = errorData;
          }
        })
        self.dataList = list;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
        self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
        self.pageIndex = self.page;
        self.total = res.mdata.total;
        self.totalPage = Math.floor((parseInt(res.mdata.total) - 1) / self.pageSize) + 1;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.querySnapshot();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.querySnapshot();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.querySnapshot();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.querySnapshot();
    },
    queryCellVoltage(beginTime) {
      let self = this;
      let params = {
        batteryNo: this.primaryDeviceNo,
        beginTime: beginTime
      };
      this.$http.post('/managementPlatform/electricity/queryBatteryCellSnapshot', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        res.ldata.forEach(v => {
          v.cellSeqNo += '号'
          v.electricVoltage += 'V'
        })
        self.tableData = res.ldata;
        self.loading = false;
      }).catch(function (response) {
        console.log(response);
      });
    },
    exprotFn(){
      let self = this;
      this.$confirm(this.$t('lang.Whether to confirm export'), "", {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.onExportClick();
        })
        .catch(action => {
        });
    },
    onExportClick() {
      let self = this;
      let params = {
        batteryNo: this.primaryDeviceNo,
        startTime: new Date(this.startTime).getTime(),
        endTime: new Date(this.endTime).getTime(),
      };
      this.$http.post("/managementPlatform/batterySnapshotExport", this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "导出失败!",
            center: true
          })
          return;
        }
        self.$message({
          type: "success",
          message: this.$t('lang.Export successful'),
          center: true
        })
        setTimeout(function () {
          self.$router.push('/managePage/downloadTask')
        }, 1000)
      }).catch(function (response) {

      });
    },
    toList() {
      this.$router.push('/managePage/batteryMgmt?searchCondition=' + this.searchCondition + "&belongTarget=" + this.belongTarget + "&targetNumber=" + this.targetNumber
        + "&belongTargetSeq=" + this.belongTargetSeq + "&version=" + this.version + "&status=" + this.status + "&manufacturer=" + this.manufacturer + "&beginIndex=" + this.listBeginIndex)
    },
    handleCurrentChange(page) {
      this.beginIndex = page ;
      this.querySnapshot();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.querySnapshot();
    },
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}
// 滚动条
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; // 横向滚动条
    height: 10px; // 纵向滚动条 必写
  }
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batterySnapShot.vue